import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPremiumCustomers } from './thunks';
import { WajeezAnalysisState } from './types';

export const name = 'wajeezAnalysis';

const initialState: WajeezAnalysisState = {
  premiumCustomers: null,
  premiumCustomersStatus: 'idle',
};
export const getPremiumCustomersAsync = createAsyncThunk(
  name + '/getPremiumCustomers',
  getPremiumCustomers
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPremiumCustomersAsync.pending, (state) => {
        state.premiumCustomersStatus = 'loading';
      })
      .addCase(getPremiumCustomersAsync.fulfilled, (state, action) => {
        state.premiumCustomersStatus = 'idle';
        state.premiumCustomers = action.payload;
      })
      .addCase(getPremiumCustomersAsync.rejected, (state, action) => {
        state.premiumCustomersStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
